import { CreateStoppageCommand, StoppagesApi, UpdateStoppageCommand } from '@operations/app/api'
import { createApiClient } from '@operations/app/http-client'

class StoppageService {
  httpClient = createApiClient(StoppagesApi)

  getByVesselVisitId = async (vesselVisitId: number) => {
    const { data } = await this.httpClient.get(vesselVisitId)
    return data
  }

  getById = async (id: number) => {
    const { data } = await this.httpClient.getById(id)
    return data
  }

  create = async (cmd: CreateStoppageCommand) => {
    await this.httpClient.create(cmd)
  }

  update = async (cmd: UpdateStoppageCommand) => {
    await this.httpClient.update(cmd)
  }

  delete = async (id: number) => {
    await this.httpClient._delete(id)
  }
}

const stoppageService = new StoppageService()

export default stoppageService
